<template>
  <div
    v-show="value"
    :style="{
      top: `${top}px`,
      left: `${left}px`
    }"
    class="custom-details-tooltip"
  >
    <!-- HEADER -->
    <div class="custom-details-tooltip--header">
      <!-- DATA -->
      <PmwParagraph v-if="attributes" fontSize="large" fontWeight="medium"
        >{{ formatDate(attributes.dates[0].start, 'dd MMMM yyyy') }}
      </PmwParagraph>
    </div>

    <!-- BODY -->
    <div class="custom-details-tooltip--body">
      <!-- PAX -->
      <b-row class="pax-row ">
        <b-col
          v-for="(pax, i) in paxValues"
          :key="`guests-${pax.label}-${i}`"
          class="pax-col mb-2"
        >
          <label>{{ pax.label }}</label>
          <p class="value">{{ pax.price }} pts</p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
/**
 * Componente da tooltip de pré-visualização dos dados
 * da data do calendário que está no estado hover
 */
import { mapGetters } from 'vuex'
import { formatDate } from '@/helpers/date'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'

export default {
  name: 'PointsDayDetailsTooltip',
  components: {
    PmwParagraph
  },
  props: {
    /** Posição top do css */
    top: {
      type: Number,
      default: 0
    },
    /** Posição left do css */
    left: {
      type: Number,
      default: 0
    },
    /** Atributos para popular o conteúdo */
    attributes: {
      type: Object,
      default: () => {}
    },
    /** Se está visível */
    value: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    /** Retorna os valores de Pax da diária */
    paxValues() {
      if (!this.attributes?.customData.paxPrices) return false
      return this.attributes?.customData.paxPrices.map((item) => {
        return {
          label: `${item.tipoPax === 10 ? 'Pax' : 'Cr'} ${item.quantidadePax}`,
          price: item.quantidadePontos
        }
      })
    },

    ...mapGetters('hotel', ['getCurrency'])
  },

  methods: {
    /** Helper de data */
    formatDate: formatDate
  }
}
</script>

<style lang="scss" scoped>
.custom-details-tooltip {
  width: auto;
  min-width: 551px;
  min-height: 156px;
  background-color: $white;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  backface-visibility: hidden;
  pointer-events: none;
  will-change: top, left;
  @include box-shadow(0px 10px 25px rgba(0, 0, 0, 0.1));

  &--header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    padding: {
      left: 30px;
      right: 30px;
    }
    background-color: $blue;
    color: $white;
    text-transform: capitalize;
  }

  &--body {
    padding: {
      left: 30px;
      right: 30px;
      top: 25px;
      bottom: 25px;
    }

    label,
    .value {
      font-weight: font-weight('weight-medium');
      font-size: font-size('size-small');
      white-space: nowrap;

      &--result {
        font-size: font-size('size-small');
        color: pmw-colors(grey-60);
        line-height: 18px;
      }
    }

    .value {
      font-weight: font-weight('weight-normal');
      color: $gray-dark;
    }
  }

  .pax {
    &-row {
      flex-wrap: nowrap;
    }

    &-col {
      width: 80px;

      label {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
